import React from "react";
import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils";

export default function TopNav() {
  const offlineMode = (process.env.REACT_APP_OFFLINE_MODE || "false").toLowerCase() === "true";
  const linkBase =
    "rounded-full px-4 py-2 text-sm ring-1 ring-white/10 bg-white/5 text-zinc-200 hover:bg-white/10";

  const active = "bg-violet-500/20 text-violet-100 ring-violet-300/20";

  return (
    <div className="border-b border-white/10 bg-black/20 backdrop-blur" data-testid="topnav">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3" data-testid="topnav-brand">
          <div className="grid h-9 w-9 place-items-center rounded-xl bg-violet-500/15 ring-1 ring-violet-300/20">
            <span className="text-sm font-semibold text-violet-100" data-testid="brand-mark">
              GX
            </span>
          </div>
          <div>
            <div className="text-sm font-semibold text-zinc-100" data-testid="brand-title">
              GenX Photo Studio
            </div>
            <div className="text-xs text-zinc-500" data-testid="brand-subtitle">
              Developed by Gen-x Digital Holdings
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2" data-testid="topnav-links">
          <NavLink
            to="/"
            className={({ isActive }) => cn(linkBase, isActive && active)}
            data-testid="nav-background-remover"
          >
            Background
          </NavLink>
          <NavLink
            to="/passport"
            className={({ isActive }) => cn(linkBase, isActive && active)}
            data-testid="nav-passport-studio"
          >
            Passport
          </NavLink>
          <NavLink
            to="/restore"
            className={({ isActive }) => cn(linkBase, isActive && active)}
            data-testid="nav-restore"
          >
            Restore
          </NavLink>
          {!offlineMode ? (
            <NavLink
              to="/admin"
              className={({ isActive }) => cn(linkBase, isActive && active)}
              data-testid="nav-admin"
            >
              Admin
            </NavLink>
          ) : null}
        </div>
      </div>
    </div>
  );
}
